import * as React from "react";
import { SelectCategoryUI } from "../select-category";
import * as AirMeltElement from "./filter-logic/min-max-values";
import { AirMeltState, INITIAL_STATE } from "./air-melt-state";
import { filteredProducts } from "./filter-logic/filtered-products";
import { AirMeltTableHeaderUI } from "./table-header-ui";
import { AirMeltTableRowUI } from "./table-row-ui";
import {
  airMeltCmOptions,
  airMeltCommonNameOptions,
  airMeltTradeNameOptions,
  airMeltAstmOptions,
  airMeltAmsOptions,
  airMeltUnsOptions,
  airMeltDinOptions,
  airMeltWnrOptions,
  airMeltAfnorOptions
} from "./air-melt-industry-info";
import { AirMeltAlloy, AirMeltCategory } from "../core/alloy-types";
import { VacuumCategoryInfo } from "../vacuum";
import { Drawer, Accordion, Typography, AccordionSummary, AccordionDetails, InputAdornment, TextField, TablePagination, Pagination } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { IndustryMultiSelectUI } from "../multi-select";
import { CompositionFilterUI } from "../composition-filter";
import SearchIcon from '@mui/icons-material/Search';
import { AccordionCategoryPreviewUI, AccordionCompositionPreviewUI, AccordionCompPreview, AccordionNamePreviewUI } from "../accordion-preview";

require("./styles.scss");
require("../../styles/shared-styles.scss");

export type TablePageUIProps = {
  products: AirMeltAlloy[];
};

export interface AirMeltCategoryInfo {
  value: AirMeltCategory;
  selected: boolean;
}

export class TableUI extends React.PureComponent<
  TablePageUIProps,
  AirMeltState
> {

  constructor(props: TablePageUIProps) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    document.title = "Product Catalog: Air Melt Alloys";
  }

  setCategories = (category: AirMeltCategoryInfo | VacuumCategoryInfo) => {
    let newState = this.state.selectedCategories.map(cat => {
      if (cat.value === category.value) {
        cat.selected = !cat.selected;
        this.resetPageIndex();
      }
      return cat;
    });

    this.setState({ selectedCategories: newState });
  };
  setSiliconRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.siliconMax) {
        this.setState({ siliconFilterSet: true });
        this.setState({ siliconMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.siliconMin) {
        this.setState({ siliconFilterSet: true });
        this.setState({ siliconMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  };
  resetSiliconFilter = () => {
    this.setState({ siliconFilterSet: false });
    this.setState({ siliconMin: INITIAL_STATE.siliconMin });
    this.setState({ siliconMax: INITIAL_STATE.siliconMax });
    this.resetPageIndex();
  };
  setChromiumRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.chromiumMax) {
        this.setState({ chromiumFilterSet: true });
        this.setState({ chromiumMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.chromiumMin) {
        this.setState({ chromiumFilterSet: true });
        this.setState({ chromiumMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  };
  resetChromiumFilter = () => {
    this.setState({ chromiumFilterSet: false });
    this.setState({ chromiumMin: INITIAL_STATE.chromiumMin });
    this.setState({ chromiumMax: INITIAL_STATE.chromiumMax });
    this.resetPageIndex();
  };
  setNickelRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.nickelMax) {
        this.setState({ nickelFilterSet: true });
        this.setState({ nickelMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.nickelMin) {
        this.setState({ nickelFilterSet: true });
        this.setState({ nickelMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  }; 
  resetNickelFilter = () => {
    this.setState({ nickelFilterSet: false });
    this.setState({ nickelMin: INITIAL_STATE.nickelMin });
    this.setState({ nickelMax: INITIAL_STATE.nickelMax });
    this.resetPageIndex();
  };
  setMolybdenumRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.molybdenumMax) {
        this.setState({ molybdenumFilterSet: true });
        this.setState({ molybdenumMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.molybdenumMin) {
        this.setState({ molybdenumFilterSet: true });
        this.setState({ molybdenumMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  };
  resetMolybdenumFilter = () => {
    this.setState({ molybdenumFilterSet: false });
    this.setState({ molybdenumMin: INITIAL_STATE.molybdenumMin });
    this.setState({ molybdenumMax: INITIAL_STATE.molybdenumMax });
    this.resetPageIndex();
  };
  setCobaltRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.cobaltMax) {
        this.setState({ cobaltFilterSet: true });
        this.setState({ cobaltMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.cobaltMin) {
        this.setState({ cobaltFilterSet: true });
        this.setState({ cobaltMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  };
  resetCobaltFilter = () => {
    this.setState({ cobaltFilterSet: false });
    this.setState({ cobaltMin: INITIAL_STATE.cobaltMin });
    this.setState({ cobaltMax: INITIAL_STATE.cobaltMax });
    this.resetPageIndex();
  };
  setIronRange = (event: any, newVal: any, boundary: string) => {
    if (boundary === "min") {
      if (newVal.props.value <= this.state.ironMax) {
        this.setState({ ironFilterSet: true });
        this.setState({ ironMin: newVal.props.value });
        this.resetPageIndex();
      }
    } else if (boundary === "max") {
      if (newVal.props.value >= this.state.ironMin) {
        this.setState({ ironFilterSet: true });
        this.setState({ ironMax: newVal.props.value });
        this.resetPageIndex();
      }
    }
  };
  resetIronFilter = () => {
    this.setState({ ironFilterSet: false });
    this.setState({ ironMin: INITIAL_STATE.ironMin });
    this.setState({ ironMax: INITIAL_STATE.ironMax });
    this.resetPageIndex();
  };
  setAirMeltCmOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ cmSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltCommonNameOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ commonNameSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltTradeNameOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ tradeNameSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltAstmOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ astmSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltAmsOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ amsSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltUnsOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ unsSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltDinOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ dinSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltWnrOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ wnrSelections: vals });
    this.resetPageIndex();
  };
  setAirMeltAfnorOptions = (event: any, options: any) => {
    let vals: string[] = options.map((o: any) => {
      if (o.value) { return o.value } 
      else { return o };
    });
    this.setState({ afnorSelections: vals });
    this.resetPageIndex();
  };

  resetAllElements = () => {
    this.resetSiliconFilter();
    this.resetChromiumFilter();
    this.resetNickelFilter();
    this.resetMolybdenumFilter();
    this.resetCobaltFilter();
    this.resetIronFilter();
    this.setState({
      cmSelections: [],
      commonNameSelections: [],
      tradeNameSelections: [],
      astmSelections: [],
      amsSelections: [],
      unsSelections: [],
      dinSelections: [],
      wnrSelections: [],
      afnorSelections: [],
      selectedCategories: [
        { value: AirMeltCategory.CarbonAndLowAlloySteels, selected: true },
        { value: AirMeltCategory.CastToolSteels, selected: true },
        { value: AirMeltCategory.StainlessSteels, selected: true },
        { value: AirMeltCategory.NickelBase, selected: true },
        { value: AirMeltCategory.CobaltBase, selected: true }
      ],
    });
    this.resetPageIndex();
  };

  handleSearchTerm(event: any) {
    if (event.target.value && typeof(event.target.value) === "string") {
      this.setState({searchTerm: event.target.value});
      this.resetPageIndex();
    } else {
      this.setState({searchTerm: null});
    }
  }

  handleDrawerChange = (value: any) => {
    if (this.state.drawerOpen) {
      this.setState({ drawerOpen: false });
    } else {
      this.setState({ drawerOpen: true }); 
    }
  }

  handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    this.setState({ openFilter: newExpanded ? panel : "" });
  };

  createSidebar() {
    const currentNameSelections: string[] = [
      this.state.cmSelections.map(s => "CM " + s),
      this.state.commonNameSelections.map(s => "CN " + s),
      this.state.tradeNameSelections.map(s => "TN " + s),
      this.state.astmSelections.map(s => "ASTM " + s),
      this.state.amsSelections.map(s => "AMS " + s),
      this.state.unsSelections.map(s => "UNS " + s),
      this.state.dinSelections.map(s => "DIN " + s),
      this.state.wnrSelections.map(s => "WNR " + s),
      this.state.afnorSelections.map(s => "AFNOR " + s) 
    ].flat();

    const currentElements: AccordionCompPreview[] = [
      { elemName: AirMeltElement.siliconInfo.title, elemMin: this.state.siliconMin, elemMax: this.state.siliconMax, filterSet: this.state.siliconFilterSet },
      { elemName: AirMeltElement.chromiumInfo.title, elemMin: this.state.chromiumMin, elemMax: this.state.chromiumMax, filterSet: this.state.chromiumFilterSet },
      { elemName: AirMeltElement.nickelInfo.title, elemMin: this.state.nickelMin, elemMax: this.state.nickelMax, filterSet: this.state.nickelFilterSet },
      { elemName: AirMeltElement.molybdenumInfo.title, elemMin: this.state.molybdenumMin, elemMax: this.state.molybdenumMax, filterSet: this.state.molybdenumFilterSet },
      { elemName: AirMeltElement.cobaltInfo.title, elemMin: this.state.cobaltMin, elemMax: this.state.cobaltMax, filterSet: this.state.cobaltFilterSet },
      { elemName: AirMeltElement.ironInfo.title, elemMin: this.state.ironMin, elemMax: this.state.ironMax, filterSet: this.state.ironFilterSet },
    ];

    return (
      <Drawer anchor="right" open={this.state.drawerOpen} 
        PaperProps={{ sx: {width: "400px"} }} 
        ModalProps={{ onBackdropClick: this.handleDrawerChange }} >
        <div className="filter-header">
          <Typography fontSize={16} fontWeight={700} color={"#383838"}>Filters</Typography>
          <CloseIcon onClick={this.handleDrawerChange}/>
        </div>
        <div className="sidebar-filters">
          <Accordion expanded={this.state.openFilter === 'categories'} onChange={this.handleAccordionChange('categories')}>
            <AccordionSummary aria-controls="categories-content" id="categories-header" expandIcon={<ExpandMoreIcon />}>  
              <Typography fontSize={16} fontWeight={700}>Categories</Typography>
              <AccordionCategoryPreviewUI 
                accordionSectionExpanded={this.state.openFilter === 'categories'}
                categoriesToPreview={this.state.selectedCategories} />
            </AccordionSummary>
            <AccordionDetails>
            <div className="filter-category">
              <SelectCategoryUI
                categoryOptions={this.state.selectedCategories}
                setCategories={this.setCategories}
              />
            </div>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={this.state.openFilter === 'names'} onChange={this.handleAccordionChange('names')}>
            <AccordionSummary aria-controls="names-content" id="names-header"  expandIcon={<ExpandMoreIcon />}>
              <Typography fontSize={16} fontWeight={700} color={"#383838"}>Names</Typography>
              <AccordionNamePreviewUI 
                accordionSectionExpanded={this.state.openFilter === 'names'}
                namesToPreview={currentNameSelections}
              />
            </AccordionSummary>
            <AccordionDetails>
              <div className="filter-names">
                <IndustryMultiSelectUI
                  industryInfo={airMeltCmOptions}
                  updateSelections={this.setAirMeltCmOptions}
                  currentSelection={this.state.cmSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltCommonNameOptions}
                  updateSelections={this.setAirMeltCommonNameOptions}
                  currentSelection={this.state.commonNameSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltTradeNameOptions}
                  updateSelections={this.setAirMeltTradeNameOptions}
                  currentSelection={this.state.tradeNameSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltAstmOptions}
                  updateSelections={this.setAirMeltAstmOptions}
                  currentSelection={this.state.astmSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltAmsOptions}
                  updateSelections={this.setAirMeltAmsOptions}
                  currentSelection={this.state.amsSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltUnsOptions}
                  updateSelections={this.setAirMeltUnsOptions}
                  currentSelection={this.state.unsSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltDinOptions}
                  updateSelections={this.setAirMeltDinOptions}
                  currentSelection={this.state.dinSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltWnrOptions}
                  updateSelections={this.setAirMeltWnrOptions}
                  currentSelection={this.state.wnrSelections}
                />
                <IndustryMultiSelectUI
                  industryInfo={airMeltAfnorOptions}
                  updateSelections={this.setAirMeltAfnorOptions}
                  currentSelection={this.state.afnorSelections}
                />
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={this.state.openFilter === 'composition'} onChange={this.handleAccordionChange('composition')}>
            <AccordionSummary aria-controls="composition-content" id="composition-header" expandIcon={<ExpandMoreIcon />}>
              <Typography fontSize={16} fontWeight={700} color={"#383838"}>Composition</Typography>
              <AccordionCompositionPreviewUI 
                accordionSectionExpanded={this.state.openFilter === 'composition'}
                compositionToPreview={currentElements}
              />
            </AccordionSummary>
            <AccordionDetails>
              <div className="filter-composition">
                <CompositionFilterUI
                  key={AirMeltElement.siliconInfo.title}
                  sliderInfo={AirMeltElement.siliconInfo}
                  updateComponentState={this.setSiliconRange}
                  elementMinState={this.state.siliconMin}
                  elementMaxState={this.state.siliconMax}
                  resetComponentState={this.resetSiliconFilter}
                  sliderActive={this.state.siliconFilterSet}
                />
                <CompositionFilterUI
                  key={AirMeltElement.chromiumInfo.title}
                  sliderInfo={AirMeltElement.chromiumInfo}
                  updateComponentState={this.setChromiumRange}
                  elementMinState={this.state.chromiumMin}
                  elementMaxState={this.state.chromiumMax}
                  resetComponentState={this.resetChromiumFilter}
                  sliderActive={this.state.chromiumFilterSet}
                />
                <CompositionFilterUI
                  key={AirMeltElement.nickelInfo.title}
                  sliderInfo={AirMeltElement.nickelInfo}
                  updateComponentState={this.setNickelRange}
                  elementMinState={this.state.nickelMin}
                  elementMaxState={this.state.nickelMax}
                  resetComponentState={this.resetNickelFilter}
                  sliderActive={this.state.nickelFilterSet}
                />
                <CompositionFilterUI
                  key={AirMeltElement.molybdenumInfo.title}
                  sliderInfo={AirMeltElement.molybdenumInfo}
                  updateComponentState={this.setMolybdenumRange}
                  elementMinState={this.state.molybdenumMin}
                  elementMaxState={this.state.molybdenumMax}
                  resetComponentState={this.resetMolybdenumFilter}
                  sliderActive={this.state.molybdenumFilterSet}
                />
                <CompositionFilterUI
                  key={AirMeltElement.cobaltInfo.title}
                  sliderInfo={AirMeltElement.cobaltInfo}
                  updateComponentState={this.setCobaltRange}
                  elementMinState={this.state.cobaltMin}
                  elementMaxState={this.state.cobaltMax}
                  resetComponentState={this.resetCobaltFilter}
                  sliderActive={this.state.cobaltFilterSet}
                />
                <CompositionFilterUI
                  key={AirMeltElement.ironInfo.title}
                  sliderInfo={AirMeltElement.ironInfo}
                  updateComponentState={this.setIronRange}
                  elementMinState={this.state.ironMin}
                  elementMaxState={this.state.ironMax}
                  resetComponentState={this.resetIronFilter}
                  sliderActive={this.state.ironFilterSet}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="filter-select-buttons">
          <div className="filter-select-reset-filters" onClick={this.resetAllElements}>
            Clear Filters
          </div>
          <div className="filter-select-set-filters" onClick={this.handleDrawerChange}>
            View Results 
          </div>
        </div>
      </Drawer>
    )
  }

  displayTableRows(productsLength: number) {
    if (this.props && this.props.products && productsLength > 0) {
      const filteredProds: AirMeltAlloy[] = filteredProducts(this.props.products, this.state);

      const zeroAdjustedPage = this.state.currentPage - 1;

      const min = zeroAdjustedPage * this.state.rowsPerPage 
      const max = zeroAdjustedPage * this.state.rowsPerPage + this.state.rowsPerPage;

      const subsetFilteredProds = filteredProds.slice(min,max);

      return subsetFilteredProds.map(p => {
        return (
          <AirMeltTableRowUI
            key={p.id}
            product={p}
          />
        );
      });
    } else {
      return (
        <div className="table-row no-products-found">
          No products found. Try removing some filters.{" "}
        </div>
      );
    }
  }

  handleChangePage = (event: any, newPage: number) => {
    this.setState({currentPage: newPage});
  }

  handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.target.value) {
      let val = parseInt(event.target.value, 10)
      this.setState({rowsPerPage: val});
      this.resetPageIndex();
    }
  }

  resetPageIndex() {
    this.setState({currentPage: 1});
  }

  countFiltersSet(): number {
    let compositionFilters = [ 
      this.state.ironFilterSet, 
      this.state.cobaltFilterSet,
      this.state.nickelFilterSet,
      this.state.siliconFilterSet,
      this.state.chromiumFilterSet,
      this.state.molybdenumFilterSet
    ];

    let compositionFiltersSetCount = compositionFilters.filter(f => f === true).length;

    let nameFilters = [
      this.state.cmSelections, 
      this.state.amsSelections,
      this.state.dinSelections,
      this.state.unsSelections,
      this.state.wnrSelections,
      this.state.astmSelections,
      this.state.afnorSelections,
      this.state.tradeNameSelections,
      this.state.commonNameSelections
    ];

    let nameFiltersSetCount = nameFilters.filter(f => f.length > 0).length;

    let categoriesFilterSetCount = this.state.selectedCategories.filter(cat => cat.selected === false).length;

    return compositionFiltersSetCount + nameFiltersSetCount + categoriesFilterSetCount;
  }

  render() {
    let productsLength = filteredProducts(this.props.products, this.state).length;

    let numberOfFilters = this.countFiltersSet();
    let filterClassName = (numberOfFilters >  0) 
      ? "selector-search-or-filter--filters selector-search-or-filter--filters-applied" :
      "selector-search-or-filter--filters"

    return (
      <div>
        {/* <div className="company-header company-header--air-melt__full">
          <div className="logo-and-title">
            <LogoUI />
            <div className="company-header--page-title">Air Melt Alloys</div>
          </div>
        </div> */}
        <div className="air-melt selector-group">
        <div className="selector-search-or-filter">
            <TextField id="outlined-search" 
              type="search" sx={{ width: "240px" }}
              placeholder="Search..."
              onChange={(event) => this.handleSearchTerm(event)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div className={filterClassName} onClick={this.handleDrawerChange}>
              <FilterAltIcon fontSize="large" />
              <span>Filters</span>
              {numberOfFilters > 0 && <div className="filter-count">{numberOfFilters}</div>}
            </div>
          </div>
        </div>
        <div className="product-table air-melt-table">
          <AirMeltTableHeaderUI />
          <div className="product-table--products-shown">
            Total: {productsLength} products
          </div>
          {this.displayTableRows(productsLength)} 
        </div>
        <div className="product-table--pagination">
          <TablePagination
            component="div"
            labelRowsPerPage="Show"
            count={productsLength}
            page={this.state.currentPage-1}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={
              [{value: 10, label: '10 rows'}, {value: 25, label: '25 rows'}, 
              {value: 50, label: '50 rows'}, { value: 100, label: '100 rows' }]
            }
          />
          <Pagination 
            count={Math.ceil(productsLength/this.state.rowsPerPage)} 
            variant="outlined" 
            shape="rounded"
            page={this.state.currentPage}
            onChange={this.handleChangePage}
          />
        </div>
        {this.createSidebar()}
      </div>
    );
  }
}
